import script from "./payroll-overtime.vue?vue&type=script&setup=true&lang=js"
export * from "./payroll-overtime.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__